import script from "./MessageCategoryDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageCategoryDetail.vue?vue&type=script&setup=true&lang=js"

import "./MessageCategoryDetail.vue?vue&type=style&index=0&id=31ee7bf1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31ee7bf1"]])

export default __exports__